import { render } from "./defaultBloc.vue?vue&type=template&id=ceb7a158&scoped=true"
import script from "./defaultBloc.vue?vue&type=script&lang=js"
export * from "./defaultBloc.vue?vue&type=script&lang=js"

import "./defaultBloc.vue?vue&type=style&index=0&id=ceb7a158&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-config-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ceb7a158"]])

export default __exports__